import { render, staticRenderFns } from "./topmenu.vue?vue&type=template&id=f83fb48a&scoped=true&"
import script from "./topmenu.vue?vue&type=script&lang=js&"
export * from "./topmenu.vue?vue&type=script&lang=js&"
import style0 from "./topmenu.vue?vue&type=style&index=0&id=f83fb48a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83fb48a",
  null
  
)

export default component.exports